import type { FaireProductEntity } from "../../entity_types/product";

export const p_4ctamjvxt2: FaireProductEntity = {
  token: "p_4ctamjvxt2",
  type: "product",
  name: "yellow teacup sticker",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/b31d737fecc1e87dd18edb57c65feae700fc43dae563c7a30bc4c443611d5940.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d59839fea10adc9240c7b3893f71ed7cfc9324f6e8cfff3a8cc132f13a4b20c6.jpeg",
  ],
  priceDollars: 2,
  description:
    'Add this sticker to your water bottle, laptop, journal, envelopes, and more. \n\nDetails:\n- vinyl sticker\n- 3" x 3"\n- Original watercolor artwork by Emily Lex\n',
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:15:10.110Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
